<template>
  <div class="vg_wrapper">
    <el-card>
      <el-row>
        <el-col :md="24">
          <el-button class="vg_mb_8" size="small" type="info" @click="buttonRefresh()">刷新</el-button>
          <SearchTable
            ref="multiTable"
            v-loading="loading"
            :columns="[
              { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
              { label: '提醒时间', prop: 'create_time', input: false, itemType: 'input', formatter: val => getDateNoTime(val, true) },
              { label: '提醒消息', prop: 'message', input: false, itemType: 'input' },
              { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false }
            ]"
            :data="tableData"
            :need-check-box="false"
            :need-fixed-height="true"
            :need-pagination="false"
            :need-search="false"
            :tableRowKey="'id'"
            @getTableData="getPushList"
          >
            <template v-slot:operation="scope">
              <el-link class="vg_mr_8" type="success" @click="operation(scope.row)">查看详情</el-link>
            </template>
          </SearchTable>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { cloneDeep } from 'lodash';
import { getDateNoTime } from '@assets/js/dateUtils';
import { api } from './js/api';

export default {
  name: 'DomesticConsultationFormPush9011',
  components: { SearchTable },
  data() {
    return {
      tableData: [],
      loading: true,
      isEditObj: [],
      multiSelection: []
    };
  },
  mounted() {
    this.initData();
    setTimeout(() => {
      this.$refs.multiTable?.refreshTableLayout();
    }, 650);
  },
  methods: {
    getDateNoTime,
    getRouteQuery(row) {
      return {
        perm_id: 144,
        sample_no: row.sample_no,
        item_name: row.item_name
      };
    },
    initData() {
      this.getPushList();
    },
    handleSelectionChange(val) {
      this.multiSelection = val;
    },
    buttonRefresh() {
      this.$refs.multiTable.resetFields();
      this.getPushList();
    },
    getPushList() {
      this.loading = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      searchForm.user_id = this.$cookies.get('userInfo').user_id;
      api.getPush9011List(searchForm).then(({ data }) => {
        this.loading = false;
        this.tableData = data;
        this.$nextTick(() => {
          this.$refs.multiTable?.refreshTableLayout();
          setTimeout(() => {
            this.$refs.multiTable?.refreshTableLayout();
          }, 650);
        });
      });
    },
    operation(row) {
      api.deletePush9011({ id: row.id }).then(() => {
        this.buttonRefresh();
        this.jump('/domestic_consultation_form_list', this.getRouteQuery(row));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.vd_completed {
  color: $color-secondary-text;
}
</style>
